"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import API from "@ym-framework/api-utils";
import DateFormat from "@/framework/timeformatter";
import SafetyHandleDialog from "@/views/managements/teammanager/components/dialog/SafetyHandleDialog.vue";
import { UiFormController } from "@/components/form/UiForm.vue";
import PassSearchForm from "@/views/managements/teammanager/components/search/PassSearchForm.vue";
import BatchOperate from "@/views/managements/teammanager/components/batchComponents/BatchOperate.vue";
import { Debounce } from "vue-debounce-decorator";
class formController extends UiFormController {
  constructor() {
    super(...arguments);
    this.state = "pass";
    this.applicant = null;
    this.ip = null;
    this.period_type = null;
    this.expiryDate = [];
  }
}
let PassRequestController = class extends Mixins(
  AccountSessionMixins
) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/application_handler_list")
    );
    this.searchStatus = {
      status: "pass"
    };
    this.formController = new formController();
    this.searchStr = "";
    this.searchStr_dates = null;
    this.searchDate = [
      // new Date().setMonth(new Date().getMonth() - 3),
      new Date(new Date().getTime() - 3600 * 1e3 * 24 * 7),
      new Date()
    ];
    this.searchParams = {
      search: {
        group: null,
        name: null
      },
      select: null
    };
    this.searchDate_dates = null;
    this.selectDatas = [];
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.batchOperates = new Map(
      function* () {
        yield [
          "batch-delete",
          require("@/views/managements/teammanager/components/batchComponents/BatchDelete.vue").default
        ];
      }()
    );
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("name")) {
        this.searchStr = this.$route.query.name;
        this.searchDate = [];
        this.searchDate_dates = {
          apply_start_time: -1,
          apply_end_time: -1
        };
        this.searchStr_dates = {
          applicant: this.searchStr
        };
        yield this.searchAllData();
      } else {
        this.gridController.query.filter = this.searchStatus;
        yield this.searchByDate(this.searchDate);
      }
    });
  }
  searchByName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = {
          applicant: searchStr
        };
        yield this.searchAllData();
        return;
      }
      if (searchStr === null || searchStr === "") {
        if (this.$route.query.hasOwnProperty("name")) {
          this.$router.push({
            path: "/security",
            query: { tab: "pass" }
          });
        }
        this.searchStr_dates = null;
        if (this.searchDate_dates && this.searchDate_dates.apply_start_time === -1) {
          this.searchDate_dates = null;
        }
        yield this.searchAllData();
      }
    });
  }
  searchByDate(searchDate) {
    return __async(this, null, function* () {
      if (searchDate !== null && searchDate.length !== 0) {
        let mintime = Date.parse(searchDate[0]);
        let maxtime = Date.parse(searchDate[1]);
        this.searchDate_dates = {
          apply_start_time: mintime,
          apply_end_time: maxtime
        };
        yield this.searchAllData();
        return;
      }
      if (searchDate === null || searchDate.length === 0) {
        this.searchDate_dates = null;
        yield this.searchAllData();
      }
    });
  }
  searchAllData() {
    return __async(this, null, function* () {
      this.clearDrawer();
      this.gridController.query.current = 1;
      this.gridController.query.filter = this.searchStatus;
      if (this.searchDate_dates !== null) {
        let obj = __spreadValues(__spreadValues({}, this.searchStatus), this.searchDate_dates);
        this.gridController.query.filter = obj;
        if (this.searchStr_dates !== null) {
          let obj2 = __spreadValues(__spreadValues(__spreadValues({}, this.searchStatus), this.searchDate_dates), this.searchStr_dates);
          this.gridController.query.filter = obj2;
        }
      }
      if (this.searchDate_dates === null) {
        this.gridController.query.filter = this.searchStatus;
        if (this.searchStr_dates !== null) {
          let obj = __spreadProps(__spreadValues(__spreadValues({}, this.searchStatus), this.searchStr_dates), {
            apply_start_time: -1,
            apply_end_time: -1
          });
          this.gridController.query.filter = obj;
        } else {
          let obj = __spreadProps(__spreadValues({}, this.searchStatus), {
            apply_start_time: -1,
            apply_end_time: -1
          });
          this.gridController.query.filter = obj;
        }
      }
      yield this.gridController.search();
    });
  }
  clearDrawer() {
    this.formController = new formController();
    this.gridController.query.params = null;
  }
  selectItems(items) {
    this.selectDatas = items;
  }
  clearBatch() {
    this.selectDatas = [];
    this._grid_table.clearSelection();
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.searchAllData();
    });
  }
  batchDelete() {
    return __async(this, null, function* () {
      try {
        let ids = _.map(this.selectDatas, "application_guid");
        yield this.$confirm(
          this.$t(
            "safetyagree.this_operation_will_permanently_delete_this_authorization_request"
          ),
          this.$t("safetyagree.prompt"),
          {
            confirmButtonText: this.$t("safetyagree.delete"),
            cancelButtonText: this.$t("safetyagree.cancel"),
            type: "warning"
          }
        );
        yield API.delete(
          `api://base.auth/api/v7/application-handles`,
          {
            data: {
              "ids": ids
            }
          }
        );
        this.$message.success(
          this.$t("safetyagree.delete_successful")
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  itemEdit(row) {
    this._safetyHandleDialog.open(row.application_guid, "edit");
  }
  itemDelete(rows) {
    return __async(this, null, function* () {
      try {
        let ids = _.map(rows, "application_guid");
        this.$confirm(
          this.$t(
            "safetyagree.this_operation_will_permanently_delete_this_authorization_request"
          ),
          this.$t("safetyagree.prompt"),
          {
            confirmButtonText: this.$t("safetyagree.delete"),
            cancelButtonText: this.$t("safetyagree.cancel"),
            type: "warning"
          }
        ).then(() => __async(this, null, function* () {
          yield API.delete(
            `api://base.auth/api/v7/handle/${ids[0]}`
          );
          this.$message.success(
            this.$t("safetyagree.delete_successful")
          );
          yield this.refresh();
        })).catch(() => {
          return;
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams.search = query.params;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      yield this.clearSearch();
      const _advancedSearchForm = PassSearchForm.create(this.formController);
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  clearSearch() {
    return __async(this, null, function* () {
      if (this.searchStr && this.searchStr !== "" && this.searchStr !== null || this.searchDate && this.searchDate.length > 0) {
        this.searchStr = "";
        this.searchDate = [];
        this.searchDate_dates = null;
        this.searchStr_dates = null;
        this.clearDrawer();
        this.gridController.query.filter = this.searchStatus;
        yield this.gridController.search();
      }
    });
  }
};
__decorateClass([
  Ref("safety-handle-dialog")
], PassRequestController.prototype, "_safetyHandleDialog", 2);
__decorateClass([
  Ref("grid-table")
], PassRequestController.prototype, "_grid_table", 2);
__decorateClass([
  Debounce(500)
], PassRequestController.prototype, "searchByName", 1);
__decorateClass([
  Debounce(500)
], PassRequestController.prototype, "searchByDate", 1);
PassRequestController = __decorateClass([
  Component({
    components: {
      UiGrid,
      SafetyHandleDialog,
      BatchOperate
    }
  })
], PassRequestController);
export {
  PassRequestController as default
};
